module.exports = __webpack_public_path__ + "img/librarybg.97dc7788.png";